import React, { useState } from 'react';
import './HelloSentences.css';

const sentences = [
  "Your next QR masterpiece awaits ⚡",
  "AI meets creativity — let’s generate 🔮",
  "Turn text into scannable magic 📲",
  "Design smarter QR codes in seconds 🤖",
  "From idea to QR — instantly 🚀",
  "Your brand, your code, powered by AI 🧠",
  "Let’s make your links unforgettable ✨",
  "Every QR tells a story — what’s yours? 📖",
  "Smart design starts with one scan 💡",
  "AI-crafted codes, made just for you 🎨",
  "Scan your imagination into life 🌈",
  "Create, customize, and captivate 💎",
  "Prompt to perfect QR in seconds 🪄",
  "Your QR, your style, your vision 🔗",
  "Where creativity meets precision 🤝",
  "Generate brilliance, one scan at a time 💫",
  "Your ideas — now beautifully scannable 📸",
  "AI that transforms links into experiences 🌟",
  "Ready to create something scannable? 🌀",
  "Let’s make your QR code unforgettable 🔥"
];

export default function HelloSentences() {
  const [current] = useState(() => {
    // Pick one random sentence for the session
    return sentences[Math.floor(Math.random() * sentences.length)];
  });

  return (
    <div className="hello-sentences">
      <h1 className="hello-text">{current}</h1>
    </div>
  );
}

